



import React, { useState, useEffect } from "react";
import "../assets/AttendanceCalculator.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchEmployeeReport } from "../redux/slices/employeeReportSlice";
import axios from "axios";

const SuperAdminAttendanceNew = () => {
  const dispatch = useDispatch();

  const { list: employeeList, loading: empLoading } = useSelector(
    (state) => state.employeeReport
  );

  const [selectedUser, setSelectedUser] = useState("");
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [selectedBranchId, setSelectedBranchId] = useState(null);
  const [superAdminId, setsuperadminid] = useState(null);

  const [selectedMonth, setSelectedMonth] = useState(new Date().toISOString().slice(0, 7));
  const [attendanceData, setAttendanceData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    employee_id: "",
    attendance_date: "",
    attendance_time: "09:30",
    checkout_time: "18:30",
  });

  useEffect(() => {
    dispatch(fetchEmployeeReport({ page: 1, pageSize: 100, filterType: "userId" }));
  }, [dispatch]);

  useEffect(() => {
    if (selectedUserId) setFormData((prev) => ({ ...prev, employee_id: selectedUserId }));
  }, [selectedUserId]);

  const formatTime = (timeValue) => {
    if (!timeValue) return "--";
    if (/^\d{2}:\d{2}$/.test(timeValue)) return timeValue;
    const dateObj = new Date(timeValue);
    if (isNaN(dateObj)) return "--";
    return dateObj.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", hour12: false, timeZone: "Asia/Kolkata" });
  };

  const fetchAttendanceData = async () => {
    if (!selectedUserId || !selectedMonth) {
      toast.info("Please select both user and month!");
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(`https://narrowitsolution.in/api/attendance/status?employee_id=${selectedUserId}&month=${selectedMonth}`);



            // const res = await fetch(`https://narrowitsolution.in/api/attendance/status?admin_id=52&month=${selectedMonth}`);

      const result = await res.json();

      
      if (result?.data?.length) {
        const mapped = result.data.map((r) => ({
          id: r.id,
          date: r.date,
          checkIn: r.check_in_time || r.checkInTime ? formatTime(r.check_in_time || r.checkInTime) : "--",
          checkOut: r.check_out_time || r.checkOutTime ? formatTime(r.check_out_time || r.checkOutTime) : "--",
          status: (r.status || "absent").trim().toLowerCase(),
        }));
        setAttendanceData(mapped);
      } else {
        toast.info("No records found.");
        setAttendanceData([]);
      }
    } catch (err) {
      toast.error("❌ Failed to fetch data!");
    } finally {
      setLoading(false);
    }
  };






  const handleSave = async (row) => {
  try {
    const payload = {
      employee_id: Number(selectedUserId),
      attendance_date: row.date, // YYYY-MM-DD

      // Convert HH:mm → HH:mm:ss
      attendance_time:
        row.checkIn && row.checkIn !== "--"
          ? `${row.checkIn}:00`
          : "09:30:00",

      // Convert to full DATETIME or null
      checkout_time:
        row.checkOut && row.checkOut !== "--"
          ? `${row.date} ${row.checkOut}:00`
          : null,

      // 🔥 THIS IS IMPORTANT
      manual_status: row.status
    };

    console.log("UPDATE PAYLOAD:", payload);

    const res = await axios.put(
      "https://narrowitsolution.in/api/attendance/update",
      payload
    );

    if (res.status === 200 || res.status === 201) {
      toast.success(`✅ Attendance for ${row.date} updated`);
      fetchAttendanceData();
    }
  } catch (error) {
    console.error("Update Error:", error);
    toast.error(
      error.response?.data?.error ||
      error.response?.data?.message ||
      "❌ Attendance update failed"
    );
  }
};

  const handleAttendanceChange = (index, field, value) => {
    const updated = [...attendanceData];
    updated[index][field] = value;
    setAttendanceData(updated);
  };

  // Rest of handleCreateSubmit and handlecalcclick remains the same...
  const handleCreateSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        employee_id: Number(formData.employee_id),
        attendance_date: formData.attendance_date,
        attendance_time: `${formData.attendance_time}:00`,
        checkout_time: `${formData.attendance_date} ${formData.checkout_time}:00`,
      };
      const res = await axios.post("https://narrowitsolution.in/api/create-attendence/custom", payload);
      if (res.status === 200 || res.status === 201) {
        toast.success("✅ Attendance Created!");
        setIsModalOpen(false);
        fetchAttendanceData();
      }
    } catch (error) {
      
      
      toast.error(
      error.response?.data?.error ||
      error.response?.data?.message ||
      "Creation failed"
    );}
  };

const handlecalcclick = async () => {
  const [year, month] = selectedMonth.split("-");
  try {
    const payload = { employeeId: selectedUserId, month, year, superAdminId, branchId: selectedBranchId };
    const response = await axios.post("https://narrowitsolution.in/api/attendence/finalize-new", payload);

    console.log("SERVER RESPONSE:", response.data); // <--- ADD THIS LOG

    if (response.data.success === true || response.data.success === "true") {
      toast.success("Salary finalized successfully!");
    } else {
      toast.error(response.data.message || "Finalization failed.");
    }
  } catch (error) {
    console.error("CATCH ERROR:", error); // <--- ADD THIS LOG
    toast.error(error.response?.data?.message || "An unexpected error occurred.");
  }
};

  return (
    <div className="SuperAdminAttendance-container">
      <div className="SuperAdminAttendance-header">
        <h1 className="SuperAdminAttendance-title"> Attendance Panel</h1>
        <button className="create-att-btn" onClick={() => setIsModalOpen(true)}>+ Create Attendance</button>
      </div>

      <div className="SuperAdminAttendance-filters">
        <div className="SuperAdminAttendance-filterGroup">
          <label className="SuperAdminAttendance-label">Select User</label>
          <select className="SuperAdminAttendance-input" value={selectedUserId || ""} onChange={(e) => {
              const userId = Number(e.target.value);
              const userObj = employeeList?.find((u) => u.id === userId);
              setSelectedUser(userObj?.fullName);
              setSelectedUserId(userObj?.id || null);
              setSelectedBranchId(userObj?.branchId || null);
              setsuperadminid(userObj?.superAdminId || null);
            }}>
            <option value="">Select User</option>
            {employeeList?.map((u) => (<option key={u.id} value={u.id}>{u.fullName} ({u.branchName})</option>))}
          </select>
        </div>
        <div className="SuperAdminAttendance-filterGroup">
          <label className="SuperAdminAttendance-label">Select Month</label>
          <input type="month" className="SuperAdminAttendance-input" value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)} />
        </div>
        <div className="SuperAdminAttendance-filterGroup">
          <label className="SuperAdminAttendance-label">&nbsp;</label>
          <button className="SuperAdminAttendance-btn" onClick={fetchAttendanceData} disabled={loading}>Filter</button>
        </div>
      </div>

      {selectedUser && attendanceData.length > 0 && (
        <div className="SuperAdminAttendance-userMonthly">
          <h2 className="SuperAdminAttendance-subtitle">Monthly Summary - {selectedUser}</h2>
          <div className="SuperAdminAttendance-summary">
            <div className="SuperAdminAttendance-card green"><h2>Days Present</h2><p>{attendanceData.filter(a => ["present", "late", "late present"].includes(a.status)).length}</p></div>
            <div className="SuperAdminAttendance-card purple"><h2>Half Days</h2><p>{attendanceData.filter(a => a.status === "half day").length}</p></div>
            <div className="SuperAdminAttendance-card red"><h2>Leaves / Absent</h2><p>{attendanceData.filter(a => ["leave", "absent"].includes(a.status)).length}</p></div>
            <div className="SuperAdminAttendance-card blue"><h2>Total Days</h2><p>{attendanceData.length}</p></div>
          </div>
        </div>
      )}

      {selectedUser && (
        <div className="SuperAdminAttendance-tableWrapper">
          <h2 className="SuperAdminAttendance-subtitle">Manage Daily Attendance</h2>
          <table className="SuperAdminAttendance-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Status</th>
                <th>Check-In</th>
                <th>Check-Out</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {attendanceData.map((row, index) => (
                <tr key={index}>
                  <td>{row.date}</td>
                  <td>
                    <select value={row.status} onChange={(e) => handleAttendanceChange(index, "status", e.target.value)}>
                      <option value="present">Present</option>
                      <option value="late">Late</option>
                      <option value="half day">Half Day</option>
                      <option value="leave">Leave</option>
                      <option value="absent">Absent</option>
                    </select>
                  </td>
                  <td><input type="time" value={row.checkIn !== "--" ? row.checkIn : ""} onChange={(e) => handleAttendanceChange(index, "checkIn", e.target.value)} /></td>
                  <td><input type="time" value={row.checkOut !== "--" ? row.checkOut : ""} onChange={(e) => handleAttendanceChange(index, "checkOut", e.target.value)} /></td>
                  <td><button className="update-btn" onClick={() => handleSave(row)}>Update</button></td>
                </tr>
              ))}
            </tbody>
          </table>
          <button className="calc-att-btn" onClick={handlecalcclick}>Finalize & Calculate Salary</button>
        </div>
      )}

      {/* Modal remains the same... */}
      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Create Custom Attendance</h3>
            <form onSubmit={handleCreateSubmit}>
              <div className="form-group"><label>Date</label><input type="date" required onChange={(e) => setFormData({...formData, attendance_date: e.target.value})} /></div>
              <div className="form-group"><label>Check-in Time</label><input type="time" defaultValue="09:30" onChange={(e) => setFormData({...formData, attendance_time: e.target.value})} /></div>
              <div className="form-group"><label>Check-out Time</label><input type="time" defaultValue="18:30" onChange={(e) => setFormData({...formData, checkout_time: e.target.value})} /></div>
              <div className="modal-btns">
                <button type="button" className="cancel-btn" onClick={() => setIsModalOpen(false)}>Cancel</button>
                <button type="submit" className="save-btn">Create</button>
              </div>
            </form>
          </div>
        </div>
      )}
      <ToastContainer position="top-right" autoClose={3000} theme="colored" />
    </div>
  );
};

export default SuperAdminAttendanceNew;